//
//
//
//
//
//
//

// 按需引入部分组件
import action from './action';

export default {
  name: 'index',
  props: ['params'],
  metaInfo: {
    title: '用户服务协议'
  },
  created: async function () {
    await this.getInfo();
  },
  data() {
    return {
      enterprise: this.params.enterpise || this.params.enterprise,
      isPlatform: this.params.is_platform == undefined ? 0 : this.params.is_platform,
      info: undefined
    };
  },
  computed: {},
  filters: {},
  components: {},
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/app/privacy/page.vue